import dayjs from 'dayjs';
import ko from 'dayjs/locale/ko';
import { createRoot } from 'react-dom/client';

import { App } from './App';

dayjs.locale(ko);

createRoot(document.getElementById('root')!).render(<App />);
